import faqAvatars from '../components/images/faq/faqAvatars';

export const GAMBIT_PAGE_PATH = '/gambit';
export const GAMBIT_CREATE_PATH = '/create/gambit';
export const HARNESS_ARTICLE_PATH = '/blog/what-is-an-agent-harness';
export const GAMBIT_PUBLISHED_DATE = '2026-10-28';

export const gambitSteps = [
  {
    title: 'Plan your story',
    text: 'Talk through your idea. Shape the characters, audience and direction in a blueprint.',
    anchor: 'blueprint',
  },
  {
    title: 'Refine your script',
    text: 'Develop the script together. Refine a scene, a line of dialogue or the whole ending.',
    anchor: 'script',
  },
  {
    title: 'Add audio and visuals',
    text: 'Direct the voices and sound, build your cast and world, then shape the storyboard.',
    anchor: 'audio',
  },
  {
    title: 'Review and share',
    text: 'Review your story, create a video or continue into another chapter.',
    anchor: 'beyond',
  },
];

export const gambitFaqs = [
  {
    question: 'What is Fable Gambit?',
    image: faqAvatars[0],
    answer:
      'Fable Gambit is a conversational AI story builder on the web. It guides you through a blueprint, script, audio, cast and world, storyboard, and video. You can discuss changes and review each stage as you build your story.',
  },
  {
    question: 'How is Gambit different from Fable Go?',
    image: faqAvatars[1],
    answer:
      'Fable Go is the familiar, simpler creation experience: choose your characters, describe an idea and let Fable build the story. Gambit gives you more control along the way, with conversation and review at each stage. Choose Go for a quick story or Gambit when you want to direct the details.',
  },
  {
    question: 'Do I need to know how to write prompts?',
    image: faqAvatars[2],
    answer:
      'No. Start with an idea or explain what you want to change in ordinary language. You can ask for a gentler ending, more natural dialogue or a different atmosphere. Gambit helps you develop that direction into a story.',
  },
  {
    question: 'Which AI models can I use?',
    image: faqAvatars[3],
    answer:
      'Gambit’s model picker includes supported models from families such as GPT, Claude and Gemini, alongside other available models. You can choose a model or use Auto select. The live picker shows the current selection and supported reasoning options; availability can change.',
  },
  {
    question: 'Can I use my own characters and voice?',
    image: faqAvatars[4],
    answer:
      'You can bring characters and voices from your Fable library into your story. Create an original character, personalize one with your photos, design a new voice or use your own voice. Only upload photos and recordings you have permission to use.',
  },
  {
    question: 'Does Gambit generate everything immediately?',
    image: faqAvatars[5],
    answer:
      'No. Planning and generation are separate. You can refine your direction and review the plan before approving a priced media generation action. Chat and generated media use tokens. Check Pricing & Plans and the in-app estimate for current access and costs.',
  },
];
